exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fb-component{padding:10px;cursor:move}.fb-component input,.fb-component label,.fb-component select,.fb-component textarea{cursor:move}.fb-form-object-editable{padding:10px}.fb-form-object-editable.fb-draggable,.fb-form-object-editable.fb-draggable input{cursor:move}.fb-form-object-editable.fb-draggable label{cursor:pointer}.fb-form-object-editable.fb-draggable select,.fb-form-object-editable.fb-draggable textarea{cursor:move}.fb-form-object-editable.empty{cursor:default;margin:6px;height:80px;border:1px dashed #aaa;background-color:#eee}.fb-draggable.dragging{background-color:#fff;position:absolute;z-index:800;box-shadow:0 0 20px #666}.fb-required:after{color:#b94a48;content:' *'}.fb-builder{min-height:250px}.popover .control-label{text-align:left}.popover form{width:240px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./bower_components/angular-form-builder/dist/angular-form-builder.css
 ** module id = 29
 ** module chunks = 0
 **/